"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dateFns = require("date-fns");
var _endsWith = _interopRequireDefault(require("lodash/endsWith"));
var _find = _interopRequireDefault(require("lodash/find"));
var _get = _interopRequireDefault(require("lodash/get"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _startsWith = _interopRequireDefault(require("lodash/startsWith"));
var _countries = _interopRequireDefault(require("../../utils/content/countries"));
var _luhnCheck = _interopRequireDefault(require("../../utils/payment/luhnCheck"));
var _replaceStringVars = _interopRequireDefault(require("../../utils/string/replaceStringVars"));
var _stripWhitespace = _interopRequireDefault(require("../../utils/string/stripWhitespace"));
var _errorKeysParser = _interopRequireDefault(require("./errorKeysParser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getTransformedDate(value) {
  var parsedInputValue = value.replace('///g', '-');
  var dateArray = parsedInputValue.split(/-|\//g);
  var yearIndex = dateArray.length === 3 ? 0 : 1;
  var monthIndex = dateArray.length === 2 ? 0 : 1;
  if (!parseInt(dateArray[monthIndex], 10) || dateArray[monthIndex] > 12) {
    return 'Invalid date';
  }

  // if two digit year value, calculate prefix, if greater than 70, assume user means 19XX
  var yearPrefix = dateArray[yearIndex].length === 2 && dateArray[yearIndex] >= 70 ? 19 : 20;

  // ensure year is 4 digit, month 0 indexed, pass in dummy day value if day doesn't exist
  var year = dateArray[yearIndex].length === 4 ? dateArray[yearIndex] : "".concat(yearPrefix).concat(dateArray[yearIndex]);
  var month = dateArray[monthIndex] - 1;
  var day = dateArray[2] || 1;
  return new Date(year, month, day);
}
var _validate = function validate(values, _ref) {
  var _ref$config$fields = _ref.config.fields,
    fields = _ref$config$fields === void 0 ? [] : _ref$config$fields;
  var errors = fields.reduce(function (acc) {
    var fieldConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = fieldConfig.name,
      required = fieldConfig.required,
      regex = fieldConfig.regex,
      minLength = fieldConfig.minLength,
      maxLength = fieldConfig.maxLength,
      luhnNumberCheck = fieldConfig.luhnNumberCheck,
      dateFormat = fieldConfig.dateFormat,
      datePresentationFormat = fieldConfig.datePresentationFormat,
      minDate = fieldConfig.minDate,
      maxDate = fieldConfig.maxDate,
      dateNotExpired = fieldConfig.dateNotExpired,
      matchField = fieldConfig.matchField,
      noWhitespace = fieldConfig.noWhitespace,
      fields = fieldConfig.fields,
      radioGroup = fieldConfig.radioGroup,
      _fieldConfig$names = fieldConfig.names,
      names = _fieldConfig$names === void 0 ? [] : _fieldConfig$names,
      options = fieldConfig.options,
      _fieldConfig$validati = fieldConfig.validationMessageKeys,
      validationMessageKeys = _fieldConfig$validati === void 0 ? {} : _fieldConfig$validati,
      validationFnc = fieldConfig.validationFnc,
      validationFncExtraArgsValueKeys = fieldConfig.validationFncExtraArgsValueKeys;
    var value = (0, _get["default"])(values, name, '');
    if (typeof value === 'string') {
      value = value.trim();
    }

    /* if (name === 'dateOfBirth') {
      console.warn('---- VALIDATE', 'value:', value, 'fieldConfig:', fieldConfig);
    } */

    // if config contains nested fields...
    if (!radioGroup && fields) {
      var fieldsErrors = _validate(values, {
        config: fieldConfig
      });
      return _objectSpread(_objectSpread({}, acc), fieldsErrors);
    }

    // if radioGroup contains comboInputs...
    // names of children in comboInputs rely on the radioValue of the parent
    // being appended to the name of the child with an underscore
    // eg: nameOfChild_radioValue
    if (radioGroup && value && names.length > 1) {
      // eslint-disable-next-line no-shadow
      var _fieldsErrors = names.reduce(function (acc, name) {
        if ((0, _endsWith["default"])(name, "_".concat(value))) {
          var _ref2 = (0, _find["default"])(fields, {
              radioValue: value
            }) || {},
            comboInputValidation = _ref2.comboInputValidation;
          var config = {
            fields: [_objectSpread({
              name: name
            }, comboInputValidation)]
          };
          return _validate(values, {
            config: config
          });
        }
        return acc;
      }, {});
      return _objectSpread(_objectSpread({}, acc), _fieldsErrors);
    }
    if (required && !value) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, validationMessageKeys.required));
    }
    if (matchField && value !== (0, _get["default"])(values, matchField)) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, validationMessageKeys.matchField));
    }
    if (maxLength) {
      var val = name.indexOf('cardNumber') !== -1 || name.indexOf('postcode') !== -1 || name.indexOf('phoneNumber') !== -1 ? (0, _stripWhitespace["default"])(value) : value;
      if (val.length > maxLength) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, validationMessageKeys.maxLength));
      }
    }
    if (minLength) {
      var _val = name.indexOf('cardNumber') !== -1 || name.indexOf('postcode') !== -1 || name.indexOf('phoneNumber') !== -1 ? (0, _stripWhitespace["default"])(value) : value;
      if (_val.length < minLength) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, validationMessageKeys.minLength));
      }
    }
    if (validationFnc && value !== '') {
      var extraParams = (validationFncExtraArgsValueKeys || []).map(function (key) {
        return (0, _get["default"])(values, key);
      });
      var error = validationFnc.apply(void 0, [value, validationMessageKeys].concat(_toConsumableArray(extraParams)));
      if (error) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, error));
      }
    }
    if (options) {
      if (!(0, _find["default"])(options, {
        value: value
      })) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, validationMessageKeys.notInOptions));
      }
    }
    if (luhnNumberCheck) {
      var _val2 = (0, _stripWhitespace["default"])(value);
      if (_val2.length >= luhnNumberCheck) {
        if (!(0, _luhnCheck["default"])(_val2)) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, validationMessageKeys.luhnNumberCheck));
        }
      }
    }
    if (noWhitespace) {
      var rawValue = (0, _get["default"])(values, name, '');
      if (rawValue && rawValue.includes(' ')) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, validationMessageKeys.noWhitespace));
      }
    }
    if (regex && value !== '' && !regex.test(value)) {
      if ((0, _startsWith["default"])(name, 'postcode') && (0, _isString["default"])(validationMessageKeys.regex)) {
        var country = (0, _find["default"])(_countries["default"], {
          value: values.countryCode
        });
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, (0, _replaceStringVars["default"])(validationMessageKeys.regex, {
          country: (0, _get["default"])(country, 'label')
        })));
      }
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, validationMessageKeys.regex));
    }
    if (minDate && value !== '') {
      if ((0, _dateFns.isBefore)((0, _dateFns.format)(value, dateFormat), (0, _dateFns.format)(minDate, dateFormat))) {
        var transformedMinDate = getTransformedDate(minDate);
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, (0, _replaceStringVars["default"])(validationMessageKeys.minDate, {
          minDate: (0, _dateFns.format)(transformedMinDate, datePresentationFormat)
        })));
      }
    }
    if (maxDate && value !== '') {
      if ((0, _dateFns.isAfter)((0, _dateFns.format)(value, dateFormat), (0, _dateFns.format)(maxDate, dateFormat))) {
        var transformedMaxDate = getTransformedDate(maxDate);
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, (0, _replaceStringVars["default"])(validationMessageKeys.maxDate, {
          maxDate: (0, _dateFns.format)(transformedMaxDate, datePresentationFormat)
        })));
      }
    }
    if (dateFormat && value !== '') {
      var transformedDate = getTransformedDate(value);
      if (!(0, _dateFns.isDate)(transformedDate)) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, validationMessageKeys.dateFormat));
      }
    }
    if (dateNotExpired && value !== '') {
      var _transformedDate = getTransformedDate(value);
      if ((0, _dateFns.isBefore)((0, _dateFns.endOfMonth)(_transformedDate), Date.now())) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, validationMessageKeys.dateNotExpired));
      }
    }
    return acc;
  }, {});
  var errorsParsed = (0, _errorKeysParser["default"])(errors);
  // console.warn('---- ERRORS:', errors);

  return errorsParsed;
};
var _default = exports["default"] = _validate;